import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';

export function DiffPills({
  oldLabel,
  newLabel,
  emptyText = '—',
  oldMaxWidth = 130,
  newMaxWidth = 130,
  fluid = false,
}) {
  const hasOld = oldLabel !== null && oldLabel !== undefined;
  const hasNew = newLabel !== null && newLabel !== undefined;
  const oldTitle = hasOld ? String(oldLabel) : '';
  const newTitle = hasNew ? String(newLabel) : '';

  if (!hasOld && !hasNew) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
        <Typography sx={{ fontFamily: 'Inter Regular, sans-serif', fontSize: 12, color: '#D1D5DB' }}>
          {emptyText}
        </Typography>
      </Box>
    );
  }

  const pillBase = {
    px: 1.5,
    py: 0.45,
    borderRadius: '5px',
    fontFamily: 'Inter Regular, sans-serif',
    fontSize: 11.5,
    textAlign: 'center',
    width: 140,
    display: '-webkit-box',
    WebkitLineClamp: 4,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    whiteSpace: 'normal',
    wordBreak: 'break-word',
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.3, width: '100%' }}>

      {/* NEW label + pill */}
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.2 }}>
        <Typography sx={{
          fontFamily: 'Inter Bold, sans-serif',
          fontSize: 9,
          fontWeight: 700,
          color: '#475569',
          letterSpacing: '0.08em',
          textTransform: 'uppercase',
          lineHeight: 1,
        }}>
          new
        </Typography>
        <Tooltip title={newTitle} placement='top' arrow disableHoverListener={!hasNew}>
          <Box sx={{
            ...pillBase,
            bgcolor: 'transparent',
            border: '1px solid #475569',
            color: '#111111',
          }}>
            {hasNew ? newLabel : <em style={{ color: '#94A3B8' }}>empty</em>}
          </Box>
        </Tooltip>
      </Box>

      {/* Arrow */}
      <Box sx={{
        width: 18,
        height: 18,
        borderRadius: '50%',
        bgcolor: '#F1F5F9',
        border: '1px solid #E2E8F0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}>
        <Typography sx={{ fontSize: 9, color: '#94A3B8', lineHeight: 1, fontWeight: 700 }}>↑</Typography>
      </Box>

      {/* OLD label + pill */}
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.2 }}>
        <Typography sx={{
          fontFamily: 'Inter Bold, sans-serif',
          fontSize: 9,
          fontWeight: 700,
          color: '#9CA3AF',
          letterSpacing: '0.08em',
          textTransform: 'uppercase',
          lineHeight: 1,
        }}>
          old
        </Typography>
        <Tooltip title={oldTitle} placement='top' arrow disableHoverListener={!hasOld}>
          <Box sx={{
            ...pillBase,
            bgcolor: '#F1F5F9',
            border: '1px solid #CBD5E1',
            color: '#64748B',
          }}>
            {hasOld ? oldLabel : <em style={{ color: '#CBD5E1' }}>empty</em>}
          </Box>
        </Tooltip>
      </Box>

    </Box>
  );
}
